export default "__VITE_ASSET__b6b10741__"